<!--  -->
<template>

    <div class="product-class-item-100">

        <div class="product-class-item-100-left">
            <h1>
                轻包装搜索
            </h1>
            <p>

                选择并搜索符合您希望的条件的轻包装。

            </p>
        </div>
        <div class="product-class-item-100-right">
            <el-form label-position="left" label-width="160px" :model="searchForm">
                <el-form-item label="通过密封搜索：">

                    <el-select v-model="searchForm.p1" placeholder="请选择密封方法">
                        <!-- <el-option label="无" value=""></el-option>
                        <el-option label="Cielo无尽" value="1"></el-option>
                        <el-option label="密封带" value="2"></el-option>
                        <el-option label="贴纸脚踩" value="3"></el-option>
                        <el-option label="装订 - 胶带" value="4"></el-option>
                        <el-option label="装订 -  Binitai" value="5"></el-option>
                        <el-option label="装订 - 抽绳" value="6"></el-option>
                        <el-option label="装订 - 扇形 " value="7"></el-option> -->
                        
                    <el-option v-for="item in pFenkous" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="通过内容搜索：">

                    <el-select v-model="searchForm.p2" placeholder="请选择包装内容">
                        <el-option label="无" value=""></el-option>
                        <el-option label="面包" value="面包"></el-option>
                        <el-option label="糖果" value="糖果"></el-option>
                        <el-option label="日常用品" value="日常用品"></el-option>
                        <el-option label="水果" value="水果"></el-option>
                        <el-option label="西点" value="西点"></el-option>
                        <el-option label="糕点" value="糕点"></el-option>
                        <el-option label="蔬菜" value="蔬菜"></el-option>
                        <el-option label="水果和蔬菜" value="水果和蔬菜"></el-option>
                        <el-option label="一般食物" value="一般食物"></el-option>
                        <el-option label="面条" value="面条"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <router-link :to="{path:'/easy/search',query:searchForm}">
            <button class="search-button">
                搜 索
            </button>
        </router-link>
    </div>
</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';

    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {},
        data() {
            //这里存放数据
            return {
                searchForm: {},
                pFenkous: [
                    {
                        value: "",
                        label: "无"
                    },
                    {
                        value: "1",
                        label: "Cielo无尽"
                    },
                    {
                        value: "2",
                        label: "密封带"
                    },
                    {
                        value: "3",
                        label: "贴纸脚踩"
                    },
                    {
                        value: "4",
                        label: "装订 - 胶带"
                    },
                    {
                        value: "5",
                        label: "装订 -  Binitai"
                    },
                    {
                        value: "6",
                        label: "装订 -  抽绳"
                    },
                    {
                        value: "7",
                        label: "装订 -  扇形"
                    }
                ],
            };
        },
        //监听属性 类似于data概念
        computed: {},
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {

        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {

        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {

        },
        beforeCreate() { }, //生命周期 - 创建之前
        beforeMount() { }, //生命周期 - 挂载之前
        beforeUpdate() { }, //生命周期 - 更新之前
        updated() { }, //生命周期 - 更新之后
        beforeDestroy() { }, //生命周期 - 销毁之前
        destroyed() { }, //生命周期 - 销毁完成
        activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style  scoped>
    .search-button {
        cursor: pointer;
        width: 90px;
        margin: 0 0 0 20px;
        height: 50px;
        background: #314478;
        border: transparent;
        font-size: 15px;
        border-radius: 5px;
        color: #fff;
        font-weight: 700;
    }
</style>